module.exports = "<p>\n  footer works!\n</p>\n"